import { createSelector } from 'reselect';

import getFilteredProducts from '../../utils/get-filtered-products';
import getProductIdsFromNeeds from '../../utils/get-product-ids-from-needs';
import selectCustomer from '../select-customer';
import selectNeedsProductType from '../select-needs-product-type';
import selectNeedsType from '../select-needs-type';
import selectProducts from '../select-products';

const selectFilteredNeedsProductsByCustomer = createSelector(
  [selectCustomer, selectNeedsProductType, selectNeedsType, selectProducts],
  (customer, needsProductType, needsType, products) => {
    if (!customer?.hospitalExcess) {
      return null;
    }

    const productIdsFromNeeds = getProductIdsFromNeeds({
      hospitalExcess: null,
      needsProductType,
      needsType,
    });

    return getFilteredProducts({
      customer,
      productIds: productIdsFromNeeds,
      products,
    });
  },
);

export default selectFilteredNeedsProductsByCustomer;
